// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  $flex?: boolean,
}

const Footer: React.ComponentType<Props> = tw.div`
  bg-white
  border-t
  fixed-bottom
  h-15
  py-1
  ${(props: Props) =>
    props.$flex
      ? `
    flex
    items-center
  `
      : null}
`

export default Footer
